export default __webpack_public_path__ + "static/media/sec-2.46efb30d.png";